import React from 'react'
import { StyledFileNameWrapper } from './styled'
import { P } from '../StyledText'

interface IStyledFileName {
  children: string
  size: string
  title?: string
}
export const StyledFileName = ({ children, size, title }: IStyledFileName) => (
  <StyledFileNameWrapper>
    <P className="file-name" title={title}>{children}</P>
    <P>{size}</P>
  </StyledFileNameWrapper>
)
